module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ba-d1e732dc96724fe02492edb7e025a9d9.svg";